
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { OrderOnBehalfService } from '@services/order-on-behalf.service';
import { OrdersDataService } from '@services/orders-data.service';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { BaseModal } from '../base-modal';

@Component({
    selector: 'api-response-modal',
    templateUrl: 'api-response.component.html',
    styleUrls: ['./api-response.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class ApiResponseModalComponent extends BaseModal {

	responseMessage: string;

	constructor(
		private router: Router,
		breadcrumbService: BreadcrumbService,
		ordersDataService: OrdersDataService,
		orderOnBehalfService: OrderOnBehalfService
	) {
		super(breadcrumbService);

		orderOnBehalfService.getCustomerOrUserNo().then(customerNo => {
			ordersDataService.reloadOrders(customerNo);
		})
	}

	async onOk() {
		this.closeAndDestroy();

		if (this.router.url != '/bag') {
			this.router.navigate(['/bag']);
		}
		else {
			window.location.reload();
		}
	}

}
